/* Publish by EComposer at 2025-08-03 13:43:45*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pxw6781dyir"]=  window.__ectimmers["ecom-pxw6781dyir"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-pxw6781dyir').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pxw6781dyir', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ke4k7yng1kj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ke4k7yng1kj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p8atiosgpi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p8atiosgpi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ixg1o92x42h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ixg1o92x42h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4c1sdh9dn9z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4c1sdh9dn9z', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-atzw4pj5uak"]=  window.__ectimmers["ecom-atzw4pj5uak"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-atzw4pj5uak"]["gb15917hv"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-atzw4pj5uak').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-atzw4pj5uak', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3ypvyfpbsyg"]=  window.__ectimmers["ecom-3ypvyfpbsyg"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-3ypvyfpbsyg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ypvyfpbsyg', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z2cqznoxujn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z2cqznoxujn', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qvbb4o04x0p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qvbb4o04x0p', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dgyivafktgg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dgyivafktgg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mf3a3n6l0cj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mf3a3n6l0cj', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l0x0ebkwb5p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l0x0ebkwb5p', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mo4zi96qni').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mo4zi96qni', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aw50nlm0orp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aw50nlm0orp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rrm8oj1hadi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rrm8oj1hadi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}